<app-heading [breadcrumbTitleOptions]="from === 'profile' ? breadcrumbTitleOptions : []" [title]="(from === 'profile' ? 'General Information' : 'Contact Information') | sentenceCase " [button]="false" [isbreadcrumb]="from === 'profile' ? true : false" [showToggle]="false"></app-heading>


<form [formGroup]="profileForm">
  @if(from === 'onboarding'){
  <div class="grid xl:w-9 w-full pt-4">
    <div class="xl:col lg:col-6 col-12">
      <p-floatLabel>
        <input
          formControlName="firstName"
          type="text"
          pInputText
          id="firstname"
        />
        <label for="firstname">{{'First Name' | sentenceCase}}<span class="required">*</span></label>
      </p-floatLabel>
    </div>
    <div class="xl:col lg:col-6 col-12">
      <p-floatLabel>
        <input
          formControlName="lastName"
          type="text"
          pInputText
          id="lastname"
        />
        <label for="lastname">{{'Last Name' | sentenceCase}}<span class="required">*</span></label>
      </p-floatLabel>
    </div>
    <div class="col-12">
        <p-floatLabel>
          <input
            formControlName="preferredFirstName"
            type="preferredFirstName"
            pInputText
            inputId="PreferredFirstName"
          />
          <label for="PreferredFirstName">Preferred First Name</label>
        </p-floatLabel>
    </div>
    <div class="col-12">
        <p-floatLabel>
          <input
            formControlName="email"
            type="email"
            pInputText
            inputId="Email"
          />
          <label for="Email">Email<span class="required">*</span></label>
        </p-floatLabel>
        @if(from === 'onboarding' && mergeInvite){
          <div class="xl:col lg:col-6 col-12" >
            <a class="merge-link" (click)="mergeAccount()"
            >Already have a {{title}} account?</a>
          </div>
        }
    </div>
    
    @if(showPasswordField){
      <div class="col-12" >
        <p-floatLabel>
          <p-password formControlName="password" [toggleMask]="true" styleClass="w-full">
            <ng-template pTemplate="footer">
              <p-divider></p-divider>
              <p class="mt-2 mb-1 font-semibold">Requirements</p>
              <ul class="pl-3 mt-0 mb-2 line-height-3 text-sm">
                <li>At least 8 characters</li>
                <li>At least one uppercase letter (A–Z)</li>
                <li>At least one lowercase letter (a–z)</li>
                <li>At least one number (0–9)</li>
                <li>At least one special character (!&#64;#$%^&*)</li>
              </ul>
            </ng-template>
          </p-password>
          <label for="Email">Password<span class="required">*</span></label>
        </p-floatLabel>
      </div>
    }
  </div>
  }
  <div
    formGroupName="profile"
    class="flex flex-column justify-content-between h-page-half"
  >
  @if(from === 'onboarding'){
    <div formGroupName="contact" class="grid xl:w-9 w-full pt-4">
      <div class="xl:col-6 lg:col-6 col-12">
        <div class="flex gap-3">
          <p-floatLabel class="w-full">
            <input (input)="formatContact($event)" maxlength="12" placeholder="000-000-0000" pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}" formControlName="home" type="tel" pInputText id="phone" />
            <label for="phone">Phone<span class="required">*</span></label>
          </p-floatLabel>
          <p-button
            label="get code"
            rounded="true"
            size="small"
            styleClass="white-space-nowrap"
            [disabled]="isPhoneVerified"
            (onClick)="sendVerificationCode()"
          ></p-button>
        </div>
      </div>
      @if(!isPhoneVerified){
      <div class="xl:col-6 lg:col-6 col-12">
        <div class="flex gap-3">
          <p-floatLabel class="w-full">
            <input type="text" pInputText id="verificationCode" #verificationCodeInput />
            <label for="verificationCode">{{'Verification Code' | sentenceCase}}<span class="required">*</span></label>
          </p-floatLabel>
          <p-button
            label="verify code"
            rounded="true"
            size="small"
            styleClass="white-space-nowrap"
            (onClick)="verify(verificationCodeInput.value)"
          ></p-button>
        </div>
      </div>
      } @else {
        <div class="xl:col-6 lg:col-6 col-12">
        </div>
      } 
      @if(!isPWCEnabled){
        <div class="col-12">
          <p-floatLabel>
            <input formControlName="street" type="text" pInputText id="address" />
            <label for="address">Address<span class="required">*</span></label>
          </p-floatLabel>
        </div>
      }
      <div class="xl:col-6 lg:col-6 col-12">
        <p-floatLabel>
          <input
            formControlName="city"
            inputId="city"
            placeholder="City"
            pInputText
          />
          <label for="city">City<span class="required">*</span></label>
        </p-floatLabel>
      </div>
      <div class="xl:col-3 lg:col-3 col-12">
        <p-floatLabel>
          <p-dropdown
            [options]="stateDropDown"
            formControlName="state"
            inputId="states"
            appendTo="body"
            optionLabel="name"
          ></p-dropdown>
          <label for="states">State<span class="required">*</span></label>
        </p-floatLabel>
      </div>
      <div class="xl:col-3 lg:col-3 col-12">
        <p-floatLabel>
          <input
            formControlName="zipCode"
            maxlength="10"
            pInputText
            id="zipCode"
          />
          <label for="zipCode">{{'Zip Code' | sentenceCase}}<span class="required">*</span></label>
        </p-floatLabel>
      </div>
    </div>
    @if(!currentTenant?.firm.isBackgroundCheckRequired && currentTenant?.firm.isCitizenshipStatusRequired){
      <div class="pl-0 pr-0 pt-5 col-4">
        <p-floatLabel>
          <p-dropdown formControlName="immigrationStatus" [options]="citizenshipType" optionLabel="name" inputId="citizenshipType"
              [placeholder]="'Citizenship Type' | sentenceCase" />
          <label for="citizenshipType">{{'Citizenship Type' | sentenceCase}}<span class="required">*</span></label>
        </p-floatLabel>
      </div>
    }
  }
    <div class="grid xl:w-12 flex-column w-full pt-4">
      @if( !from || from !== 'onboarding' && !isPwcEnabled){
      <div class="xl:col-12 lg:col-12 col-12  flex flex-row justify-content-end" [ngClass]="{'leave-pwc-wrapper': isPwcEnabled}" >
        <p-button (click)="showLeaveFirmConfirmation()" [disabled]="currentTenant?.isDeleted" [loading]="leaveRequestInProgress" [rounded]="true" icon="pi pi-sign-out" size="small" styleClass="leave-firm-button w-full p-button-icon-left" label="leave {{(currentTenant?.firm?.name | sentenceCase)}}"></p-button>
      </div>
      }
      @if (!currentTenant?.firm.isSingleSearchMarketEnabled) {
        <div class="xl:col-6 lg:col-6 col-12 flex ">
          <div class="pl-0 col-11">
            <p-floatLabel>
              <p-multiSelect
                formControlName="searchMarkets"
                display="chip"
                [showClear]="true"
                [options]="searchMarketDropdown"
                optionLabel="label"
                optionValue="value"
                inputId="searchMarket"
                (onChange)="onSearchMarketDropdownChange($event)"
                [resetFilterOnHide]="true"
              />
              <label for="searchMarket">{{'Search Markets' | sentenceCase}}<span class="required">*</span></label>
            </p-floatLabel>
          </div>
          <div class="col-1 flex align-items-center">
            <span 
              [pTooltip]="title + ' uses Search Markets to geographically target job offers to candidates in the correct regions (when required). Please select any search markets you are willing and able to work in.' | sentenceCase" 
              tooltipPosition="top" 
              icon="true"
              class="{{helperService.getEnvironmentName()}}-icon icon-info-outlined cursor-pointer text-primary-600"></span>
          </div>
        </div>
      }
      @if (!currentTenant?.firm.isSingleJobTypeEnabled) {
        <div class="xl:col-6 lg:col-6 col-12 flex flex-row">
          <div class="pl-0 col-11">
            <p-floatLabel>
              <p-multiSelect
                formControlName="jobCategories"
                display="chip"
                [options]="jobType"
                placeholder="Click all that apply"
                [disabled]="isJobTypeDisabled"
                optionLabel="label"
                optionValue="value"
                inputId="jobTypes"
                (onChange)="onJobCategoryDropdownChange($event)"
                [resetFilterOnHide]="true"
              />
              <label for="jobTypes">{{'Job Types' | sentenceCase}}<span class="required">*</span></label>
            </p-floatLabel>
          </div>
          <div class="col-1 flex align-items-center">
            <span 
            [pTooltip]="'Job Types help ' + title + ' firms target job offers at specific industries and/or specialities. Please select any Job Types you are willing and able to work in.'" 
            tooltipPosition="top" 
            icon="true"
            class="{{helperService.getEnvironmentName()}}-icon icon-info-outlined cursor-pointer text-primary-600"></span>
          </div>
        </div>
      }
    </div>
    
    <!-- Only show the privacy policy section if not already accepted -->

    @if(from === 'onboarding') {
      <div class="field-checkbox mt-4">
        <div class="flex align-items-center">
          <p-checkbox 
            formControlName="privacyPolicy" 
            [binary]="true" 
            inputId="privacyPolicy"
            >
          </p-checkbox>
          <label for="privacyPolicy" class="ml-2">
            I have read and agree to the <a target="_blank" href="{{ privacyPolicyUrl }}">Privacy Policy</a> and the <a target="_blank" href="{{ termsOfServiceUrl }}">Terms of Service</a>
          </label>
        </div>
        @if(profileForm.get('profile')?.get('privacyPolicy')?.invalid && (profileForm.get('profile')?.get('privacyPolicy')?.touched || profileForm.get('profile')?.get('privacyPolicy')?.dirty)) {
        <div class="flex align-items-center mt-2">       
          <small class="flex"  
              class="p-error block mt-1">
            You must accept the Privacy Policy to continue.
          </small>
        </div>
      }
      </div>
    }
  </div>
    <div class="flex gap-3 mt-3">
      <p-button
        label="back"
        rounded="true"
        outlined="true"
        size="large"
        [disabled]="from === 'onboarding'"
        styleClass="white-space-nowrap"
        (onClick)="onBack()"
      ></p-button>
      <p-button
        [label]="from === 'onboarding' ? 'Next' : 'Save'"
        rounded="true"
        size="large"
        [disabled]="!profileForm.valid"
        styleClass="white-space-nowrap freshgreen-background"
        (onClick)="onSubmit()"
      ></p-button>
      @if(isSkipButtonEnabled){
       <p-button
        label="skip onboarding"
        rounded="true"
        outlined="true"
        size="large"
        styleClass="white-space-nowrap"
        (onClick)="navigateToDashboard()"
        ></p-button>
      }
    </div>
</form>
